/** Shared Blokko stepper styles — ISO Enrollment, Acquirer, Merchant forms. */
export const blokkoStepperSx = {
  mb: 3,
  py: 2,
  px: { xs: 2, sm: 3, md: 4 },
  bgcolor: 'blokko.taglineMist',
  borderRadius: 2,
  width: '100%',
};

export const blokkoStepLabelSx = (isActive) => ({
  cursor: 'pointer',
  '& .MuiStepLabel-label': {
    color: isActive ? 'primary.main' : 'text.secondary',
    fontWeight: isActive ? 700 : 400,
  },
});
